import React, { DragEvent, useState } from 'react'


//styled components
import { DropZoneState, DropZone } from './DragAndDrop.styles'


export type DragAndDropProps = {
  allowedFileTypes: string[];
  allowMultiple: boolean;
  onDropFiles: (files: FileList) => void;
  onDropOther: (blob: Blob, name: string) => void;
  onDone: () => void;
}



export const DragAndDrop: React.FC<DragAndDropProps> = ({allowedFileTypes, allowMultiple, onDropFiles, onDropOther, onDone}) => {

  const [dropState, setDropState] = useState(DropZoneState.NoTarget);


  const handleDragEnter = (event: DragEvent) => {
    event.preventDefault();
    let validTarget = false;

    if (event.dataTransfer.types.some(type => type === 'Files')) { // drag files from os
      const items = [...event.dataTransfer.items];
      validTarget = allowMultiple ? items.length > 0 : items.length === 1
        && items.every(item => item.kind === 'file' && allowedFileTypes.some(type => item.type.startsWith(type)));
    } else if(allowedFileTypes.some(allowed => allowed.startsWith('image'))) { // support image drag from browser
      validTarget = event.dataTransfer.types.some(type => type.includes('file-promise'));
    }             
    if (validTarget)
      setDropState(DropZoneState.ValidTarget);
    else
      setDropState(DropZoneState.InvalidTarget);
  };

  const handleDragOver = (event: DragEvent) => {
    event.preventDefault();

    event.dataTransfer.dropEffect = dropState === DropZoneState.ValidTarget ? 'copy' : 'none';
  };

  const handleDragLeave = (event: DragEvent) => {
    event.preventDefault();
    setDropState(DropZoneState.NoTarget);
    onDone();
  };


  const handleDrop = (event: DragEvent) => {
    event.preventDefault();

    if (dropState === DropZoneState.ValidTarget) {
      if (event.dataTransfer.files.length > 0) {
        onDropFiles(event.dataTransfer.files);
      } else {
        let html = event.dataTransfer.getData('text/html');
        let match = html && /\bsrc="?([^"\s]+)"?\s*/.exec(html);
        let url = match && match[1];

        if (url) {
          let img = new Image();
          let c = document.createElement('canvas');
          let ctx = c.getContext('2d');
   
          img.onload = () => {
              c.width = img.naturalWidth;   // update canvas size to match image
              c.height = img.naturalHeight;
              ctx?.drawImage(img, 0, 0);    // draw in image
              c.toBlob(blob => {            // get content as PNG blob
                if (blob) {
                  // call our main function
                  onDropOther(blob, url!);
                }
              }, 'image/png');
          };
          img.onerror = function() {
              alert('Error in loading');
          }
          img.crossOrigin = '';              // if from different origin
          img.src = url;
        }
      }
    }

    setDropState(DropZoneState.NoTarget);
    onDone();
  };


  return (
    <DropZone className='drop-zone' state={dropState}
      onDragEnter={handleDragEnter}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop} />
  );
};

export default DragAndDrop;